import { useState, type FormEvent } from 'react';
import { useAffiliateSession } from '../contexts/AffiliateSessionContext';
import { ApiError } from '../lib/api';
import { DemoModeLink } from '../components/DemoModeLink';

// Tela inicial do influenciador — SEM conta, senha ou cadastro (pedido
// explícito do proprietário). Só e-mail, verificado contra a planilha do
// Google mantida pelo proprietário (ver worker/src/lib/affiliateSheet.mjs).
// Nenhuma informação é mostrada antes da validação. Erro é SEMPRE a mesma
// mensagem genérica, nunca revela se o e-mail existe ou não na planilha.
export function InfluencerLoginPage() {
  const { login } = useAffiliateSession();
  const [email, setEmail] = useState('');
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState<string | null>(null);

  async function handleSubmit(event: FormEvent) {
    event.preventDefault();
    setLoading(true);
    setError(null);

    try {
      await login(email.trim());
    } catch (err) {
      setError(err instanceof ApiError ? err.message : 'Não encontramos um influenciador com esse e-mail.');
    } finally {
      setLoading(false);
    }
  }

  return (
    <div className="flex min-h-screen items-center justify-center px-4">
      <div className="card w-full max-w-sm p-6">
        <h1 className="font-display text-lg font-semibold tracking-tight">Consulte seus resultados</h1>
        <p className="mt-1 text-sm text-[rgb(var(--text-muted))]">CA Render · painel de afiliados</p>

        <form className="mt-6 space-y-4" onSubmit={handleSubmit}>
          <div>
            <label className="label" htmlFor="email">
              E-mail
            </label>
            <input
              id="email"
              type="email"
              required
              autoFocus
              className="input"
              value={email}
              onChange={(event) => setEmail(event.target.value)}
              placeholder="voce@exemplo.com"
            />
          </div>
          {error ? <p className="text-sm text-error">{error}</p> : null}
          <button type="submit" className="btn-primary w-full" disabled={loading}>
            {loading ? 'Consultando…' : 'Ver meus resultados'}
          </button>
        </form>
        <DemoModeLink to="/" />
      </div>
    </div>
  );
}
